import { MECHANICS } from '@/data/mechanic';
import { $activeItem, setActiveItem } from '@/stores/itemStore';
import { $activeTool } from '@/stores/toolStore';
import { Icon } from '@iconify/react';
import { useStore } from '@nanostores/react';

export function ItemPanel() {
  const activeTool = useStore($activeTool);
  const activeItem = useStore($activeItem);

  return (
    <aside className="pointer-events-auto rounded-xl border border-white/20 bg-[#08111fcc] p-2 backdrop-blur-sm">
      <p className="mb-2 px-1 text-xs tracking-[0.12em] text-white/80 uppercase">
        Items
      </p>
      <div className="">
        {MECHANICS.map((item, i) => {
          if (item === null) {
            // new line
            return (
              <div key={i} className="my-2 w-full border-t border-white/20" />
            );
          }
          const active = activeTool === 'place' && activeItem === item.id;

          return (
            <button
              key={item.id}
              type="button"
              aria-label={item.label}
              aria-pressed={active}
              title={item.label}
              onClick={() => setActiveItem(item.id)}
              className={`inline-flex h-10 w-10 items-center justify-center rounded-md border transition ${
                active
                  ? 'border-[#c6f3ff]/80 bg-[#2f6d85] text-[#e8f9ff]'
                  : 'border-white/20 bg-white/5 text-white/80 hover:bg-white/10'
              }`}
            >
              <Icon icon={item.icon} className="h-5 w-5" />
            </button>
          );
        })}
      </div>
    </aside>
  );
}
